import React, { useEffect } from "react";

export default function MasterModal({
	open,
	onClose,
	title,
	subtitle,
	children,
	footer,
	maxWidth = 560,
}) {
	useEffect(() => {
		if (!open) return;
		const onKey = (e) => {
			if (e.key === "Escape") onClose();
		};
		document.addEventListener("keydown", onKey);
		document.body.style.overflow = "hidden";
		return () => {
			document.removeEventListener("keydown", onKey);
			document.body.style.overflow = "";
		};
	}, [open, onClose]);

	if (!open) return null;

	return (
		<div
			className="master-modal-overlay"
			role="dialog"
			aria-modal="true"
			aria-labelledby="master-modal-title"
			onClick={onClose}
		>
			<div
				className="master-modal"
				style={{ maxWidth }}
				onClick={(e) => e.stopPropagation()}
			>
				<div className="master-modal__header">
					<div className="min-w-0">
						<h2
							id="master-modal-title"
							className="text-lg font-bold text-default-900 dark:text-default-50 m-0"
						>
							{title}
						</h2>
						{subtitle && (
							<p className="text-sm text-default-500 dark:text-default-400 mt-1 mb-0">
								{subtitle}
							</p>
						)}
					</div>
					<button
						type="button"
						className="btn-ghost shrink-0 !p-2"
						onClick={onClose}
						aria-label="Fechar"
					>
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
							<path d="M18 6L6 18M6 6l12 12" />
						</svg>
					</button>
				</div>
				<div className="master-modal__body">{children}</div>
				{footer && <div className="master-modal__footer">{footer}</div>}
			</div>
		</div>
	);
}
